import { AI_MEDIA_GENERATION } from './constants';

export const mediaGenerationApi = (request, getAPICallObject) => payload => {
    const url = `${AI_MEDIA_GENERATION}`;
    return request(url, getAPICallObject('POST', payload));
};